import React, { useEffect, Fragment, useState } from "react";
import { Helmet } from "react-helmet";

import { Navigate, useNavigate } from "react-router";
import { CheckUser, GetSeo } from "./Components/Services";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const Check = ({ isModal, setShowSignup, setShowLogin, setShowCheck }) => {
  const initialState = {
    loading: false,
    data: {
      mobile: "",
    },
  };

  const { user_type } = useSelector(state => state);
  const inviteCode = window.location.href.split("?")[1];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [state, setState] = useState(initialState);

  const CheckUserHandler = mobile => {
    setState({ ...state, loading: true });
    CheckUser(mobile).then(result => {
      if (result && result.user) {
        dispatch({
          type: "SET",
          payload: { mobile: mobile },
        });
        if (!isModal) {
          navigate("/VeryfyCode", {
            state: { mobile: state.data.mobile },
          });
        }
        else {
          setShowLogin(true)
          setShowCheck(false)
        }
      } else {
        dispatch({
          type: "SET",
          payload: { mobile: mobile },
        });

        if (!isModal) {
          navigate("/Signup", {
            state: { mobile: state.data.mobile, inviteCode },
          });
        }
        else {
          setShowSignup(true)
          setShowCheck(false)
        }

      }
    });
  };

  if (user_type) {
    return <Navigate to={"/User/Dashboard"} />
  }
  return (
    <Fragment>
      {!isModal &&
        <Helmet>
          <title>نیکوتن | ورود به سایت</title>
        </Helmet>
      }
      <div className={"main-login d-flex justify-content-center align-items-center " + (!isModal && "py-4 ")
        + (window.screen.width > 575 ? !isModal && "my-5" : "my-0")}>
        <div className="container-fluid px-3 px-md-5">
          <div className="d-flex justify-content-center">
            <div
              className={"rounded-11 login w-100 " + (!isModal && "part-padding")}
              style={{
                boxShadow: !isModal && "rgba(0, 0, 0, 0.12) 0px 0px 3px, rgba(0, 0, 0, 0.24) 0px 0px 5px",
                maxWidth: !isModal && "450px",
                width: !isModal && "100%"
              }}
            >
              <div className="center">
                <div className="top mb-5 d-flex flex-column align-items-center justify-content-center">
                  <Link to={"/"}>
                    <img
                      className="img"
                      style={{ width: window.screen.width > 575 ? "150px" : "100px" }}
                      src={window.origin + "/WebSide/assets/images/logo.png"}
                      alt="nikotan | نیکوتن"
                    />
                  </Link>
                  <img
                    style={{ width: window.screen.width > 575 ? "100%" : "80%" }}
                    className="mt-1"
                    src={window.origin + "/WebSide/assets/images/sam.png"}
                  />
                </div>
                <div className="form-group login-form-group mb-3 mx-auto">
                  <h3 style={{ color: "#404040" }}>وررود / ثبت نام</h3>
                  <p
                    className="h6 mb-2"
                    style={{ color: "#404040", marginRight: "13px" }}
                  >
                    شماره موبایل خود را وارد نمایید
                  </p>
                  <div className="inputt-group d-flex">
                    <input
                      style={{ borderRadius: "10px" }}
                      className="form-control mb-2"
                      type="text"
                      dir="ltr"
                      value={state.data.mobile}
                      onChange={e => {
                        setState({
                          ...state,
                          data: { ...state.data, mobile: e.target.value },
                        });
                      }}
                      onKeyDown={e => {
                        if (e.key == "Enter") {
                          CheckUserHandler(state.data.mobile);
                        }
                      }}
                      placeholder="0912 *** ** **"
                    />
                    {/* <input className="form-control number" value="98+" /> */}
                  </div>
                </div>
                <button
                  onClick={() => CheckUserHandler(state.data.mobile)}
                  disabled={state.data.mobile.length < 11}
                  style={{ borderRadius: "10px" }}
                  className={`btn btn-red-v2 w-100 h6 mb-3 text-white ${state.loading ? "disabled" : null}`}
                >
                  {state.loading ? "در حال پردازش..." : "ورود به نیکوتن"}
                </button>
                <p className="text-center" style={{ color: "#404040", whiteSpace: "break-spaces" }}>
                  با ورود و یا ثبت نام در نیکوتن{" "}
                  <span style={{ color: "#E42A3F" }}> شرایط و قوانین </span>
                  استفاده از خدمات نیکوتن و{" "}
                  <span style={{ color: "#E42A3F" }}>
                    قوانین حریم خصوصی
                  </span>
                  آن را می پذیرند
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );

};

export default Check;
